export const pricingPlans = [
  {
    id: 'basic',
    name: 'Basic',
    subtitle: 'Everything you need to get started with your business',
    monthlyPrice: 1399,
    originalMonthlyPrice: 2798,
    originalYearlyPrice: 2518,
    yearlyPrice: 1259,
    currency: '₹',
    features: [
      'All WhatsApp Business API features',
      'First 1,000 service messages free every month; ₹0.15 per message thereafter',
      'Up to 10 Tags',
      'Up to 5 Custom Attributes',
      '1 Owner + 5 FREE Agents included',
      'Additional Agents at ₹500/month each',
      'Smart Audience Segmentation',
      'Broadcasting & Retargeting',
      'Template Message APIs',
      'Multi-Agent Live Chat',
      'Agent Transfer & Manager Monitoring',
      'Marketplace Integrations',
      '2400 Messages/min',
      'Shopify & WooCommerce Integrations',
      'Dialogflow Chatbot Integration',
      'Shared Team Inbox',
      'Click-to-WhatsApp Ads Manager'
    ],
    messageCharges: [
      { type: 'Marketing', price: '₹1.08' },
      { type: 'Utility Charges', price: '₹0.15' },
      { type: 'Service', price: '1,000 free / month' },
      { type: 'Authentication', price: '₹0.15' }
    ],
    popular: false
  },
  {
    id: 'pro',
    name: 'Pro',
    subtitle: 'Highly recommended plan to make the best use of Retargeting Campaigns',
    monthlyPrice: 2999,
    originalMonthlyPrice: 5998,
    originalYearlyPrice: 5398,
    yearlyPrice: 2699,
    currency: '₹',
    features: [
      'All features in Basic Plan',
      'Up to 100 Tags',
      'Up to 20 Custom Attributes',
      'Campaign Scheduler',
      'Campaign Click Tracking',
      'Smart Agent Routing',
      'Campaign Budget Analytics',
      'Project APIs',
      'Custom Agent Rules',
      'Carousel Template Click Tracking',
      'CSV Campaign Scheduler',
      'Google Sheets integration',
      'Birthday automation message',
      'User Access Control',
      'Automatic Failed Message Retry',
      '1 Owner + 5 FREE Agents included',
      'Additional Agents at ₹500/month each'
    ],
    messageCharges: [
      { type: 'Marketing', price: '₹1.08' },
      { type: 'Utility Charges', price: '₹0.15' },
      { type: 'Service', price: '1,000 free / month' },
      { type: 'Authentication', price: '₹0.15' }
    ],
    popular: true
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    subtitle: 'Recommended for 5 Lac+ Messages per month',
    monthlyPrice: 'Custom',
    yearlyPrice: 'Custom',
    currency: '',
    features: [
      'All features in Pro Plan',
      'Recommended for Brands with 5 Lac+ Users',
      'Unlimited Tags',
      'Unlimited Attributes',
      'Downloadable Reports',
      'Dedicated Account Manager',
      'Priority Customer Support',
      'Webhooks',
      'Higher Messaging Speed',
      'Custom Integration Support',
      'Advanced Analytics Dashboard',
      'White-label Solutions'
    ],
    messageCharges: [
      { type: 'Marketing', price: '₹1.08' },
      { type: 'Utility Charges', price: '₹0.15' },
      { type: 'Service', price: '1,000 free / month' },
      { type: 'Authentication', price: '₹0.15' }
    ],
    popular: false
  }
];

export const faqs = [
  {
    question: "What is WhatsApp's per-template message pricing?",
    answer: "WhatsApp has shifted from per-conversation to per-template message pricing. Now, you'll pay only for each template message sent—giving you clearer control over messaging costs."
  },
  {
    question: "Are WhatsApp Conversations managed separately?",
    answer: "Yes, WhatsApp Conversation Credits are recharged and managed separately. Every time you initiate a Conversation (UIC or BIC), the price of that conversation is deducted from this recharge. This price varies according to the user's country."
  },
  {
    question: "What is a Customer Service Window / Session Window?",
    answer: "A Messaging session window starts when a user sends your WhatsApp Business Number a message and lasts for 24 hours from the most recently received message. You can intervene/respond with ANY kind of message within these 24 hours."
  },
  {
    question: "Is it a Pre-paid Billing or Post-paid?",
    answer: "All billings are Pre-paid."
  },
  {
    question: "How many Contacts Can I Import?",
    answer: "You can Import Unlimited Contacts to the Dashboard. You're only charged for the WhatsApp Conversations you initiate with a user."
  },
  {
    question: "How do Upgrade or Downgrade work?",
    answer: "Upgrades and Downgrades work on a pro-rata basis."
  },
  {
    question: "Is there any WhatsApp Business API procurement fee?",
    answer: "No. We don't charge a single penny to procure the WhatsApp Business API for a Brand/Business. Businesses can procure the API for completely Free."
  }
];

export const clientLogos = [
  { name: 'PhysicsWallah', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+1' },
  { name: 'WIPRO', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+2' },
  { name: 'Aditya Birla', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+3' },
  { name: 'Angel One', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+4' },
  { name: 'HomeLane', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+5' },
  { name: 'Vivo', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+6' },
  { name: 'Adani', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+7' },
  { name: 'Tata Motors', logo: 'https://via.placeholder.com/150x80/0066CC/FFFFFF?text=Client+8' }
];

export const messageTypes = [
  {
    icon: 'MessageCircle',
    title: 'Customer Service Window',
    description: 'When a user sends you a message, a 24-hour support window begins. Each new message from the user resets this window. Service message billing follows the monthly allowance: the first 1,000 service messages are free, with a ₹0.15 utility charge per additional message.'
  },
  {
    icon: 'Gift',
    title: '1,000 Free Service Messages Every Month',
    description: 'Starting from your first month, the first 1,000 service messages are free every month. After the first 1,000, additional service messages are charged at the utility rate of ₹0.15 (15 paise) per message.'
  },
  {
    icon: 'Megaphone',
    title: 'Marketing messages',
    description: 'Marketing messages include all promotional messages, offers, product updates. Marketing messages are charged at ₹1.08 per message.'
  },
  {
    icon: 'ShoppingCart',
    title: 'Utility messages',
    description: 'Utility messages are transactional in nature and include messages for delivery updates, transaction receipts, reminders and more. Utility messages are charged at ₹0.15 per message.'
  },
  {
    icon: 'Shield',
    title: 'Authentication messages',
    description: 'Authentication messages include messages used for verification purposes such as OTP, account registration and account recovery. WhatsApp charges separately for each authentication message.'
  },
  {
    icon: 'HeadphonesIcon',
    title: 'Service messages',
    description: 'Service messages include customer support, chatbot support and user queries. The first 1,000 service messages are free each month, including the first month. Additional service messages cost ₹0.15 per message at the utility rate.'
  }
];